/**
 * Created by shiyonggao on 2019/2/25.
 */

const lodash = require('lodash');

const state = {
    app_logo : null
};

const actions = {

    /**
     * 获取应用logo
     * @param state
     * @param commit
     * @param rootState
     * @constructor
     */
    GET_APP_LOGO({state, commit, rootState}){
        const versionInfo = rootState.$appConfig.getVersionInfo();
        let url = versionInfo.api.app_base_url + versionInfo.api.app_logo;

        let params = {
            merchant_shop_code: rootState.$appConfig.PARAMS.merchant_shop_code,
        };

        rootState.$common.ajax({
            url: url,
            data: params,
            success(res) {
                console.log('AJAX_GET_LOGO_INFO=>', res);
                if (res.code === 200) {

                    if(!lodash['isArray'](res.result)){
                        commit('SER_APP_LOGO', res.result.logo);
                    }
                    commit('SET_AJAX_STATUS', ['logo', true], {root: true});
                }
            },
            error(res) {
                console.log('AJAX_LOGO_ACCES_FAIL=>', res);
            }
        });
    }
};

const getters = {};

const mutations = {
    /**
     * 更新应用LOGO
     * @param state
     * @param imageUrl
     * @constructor
     */
    SER_APP_LOGO(state, imageUrl) {
        if(imageUrl){
            state.app_logo = imageUrl;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/get_app_logo.js